module.exports = __webpack_public_path__ + "static/media/CHUONGTRINHGIANGDAY-03.414be490.png";